import { render, staticRenderFns } from "./assigned_tree_selection.vue?vue&type=template&id=36b1e9e0&scoped=true"
import script from "./assigned_tree_selection.vue?vue&type=script&lang=js"
export * from "./assigned_tree_selection.vue?vue&type=script&lang=js"
import style0 from "./assigned_tree_selection.vue?vue&type=style&index=0&id=36b1e9e0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36b1e9e0",
  null
  
)

export default component.exports